import React, { useContext, useEffect, useState } from 'react';
import AgreementsList from '../LeasingComponents/AgreementsList';
import { useForm } from 'react-hook-form';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useDispatch } from 'react-redux';
import Dialog from 'src/components/common/Dialog.redesign';
import { push } from 'connected-react-router';
import Owner from 'src/models/tract_detail/Owner';
import useFetch from 'use-http';
import { ODataFilter, ODataFilterOperators, ODataOptions, ODataOrderByDirection } from 'src/util/ODataBuilder';
import PagedResultSet from 'src/models/common/PagedResultSet';
import ContractGenerationListDto from 'src/models/leasing/ContractGenerationListDto';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import ContractOwnershipList from 'src/models/ContractOwnershipList';

// TODO: Need to make this component more modular to allow for all of contract types!

interface IManageAgreementDialog {
    ownershipId: number;
    hideDialog?: () => void;
    selectedOwner?: Owner;
}

type FormType = {
    agreementType: string;
};

const aTypes = [
    { id: 1, name: 'Oil & Gas Lease' },
    { id: 2, name: 'Solar Lease' },
    { id: 3, name: 'Surface Waiver' },
    { id: 4, name: 'Battery Storage' },
    { id: 5, name: 'Brine Lease'}
];

const ManageAgreementDialog = (props: IManageAgreementDialog) => {
    const appContext = useContext<IAppContextState>(AppContext);
    const { handleSubmit, register } = useForm();
    const { get, response } = useFetch();
    // const { get } = useFetch();
    const dispatch = useDispatch();

    const [existingContracts, setExistingContracts] = useState<PagedResultSet<ContractGenerationListDto>>(undefined);
    const [contractNumbers, setContractNumbers] = useState<string[]>([]);

    useEffect(() => {
        getContractNumbers();
    }, []);

    useEffect(() => {
        if (contractNumbers.length > 0) {
            getContractsForOwner();
        }
    }, [contractNumbers]);

    const navigate = (path: string) => {
        dispatch(push(path));
        
        props.hideDialog();
    };

    // TODO: Consolidate these into one call.
    const getContractsForOwner = async () => {
        const options = new ODataOptions();

        options.addOrderBy('leaseNumber', ODataOrderByDirection.Descending);
        for (let num of contractNumbers) {
            options.addFilter(new ODataFilter('where', ODataFilterOperators.Equals, 'leaseNumber,' + num));
        }

        let data: PagedResultSet<ContractGenerationListDto> = await get(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases/paged/${options.toString()}`);

        if (response.ok) {
            setExistingContracts(data);
        } else {
            console.log('Unable to get Existing Contracts', response);
        }
    };

    const getContractNumbers = async () => {
        const result: Array<ContractOwnershipList> = await get(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases/ownershipId/${props.ownershipId}/contracts/true`
        );

        if (response.ok && result?.length > 0) {
            setContractNumbers(result.map(co => co.agreementNumber));
        }
    };

    const formSubmit = (values: FormType) => {
        let contractsPath: string = `/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/acquisitions`;
        switch (values?.agreementType) {
            case '1':
                navigate(`${contractsPath}/lease-generation/ownerId/${props?.selectedOwner?.ownerLookUpId}/leases/new-lease`);
                break;
            case '2':
                navigate(`${contractsPath}/lease-generation/ownerId/${props?.selectedOwner?.ownerLookUpId}/solar-leases/new-lease`);
                break;
            case '3':
                navigate(`${contractsPath}/lease-generation/ownerId/${props?.selectedOwner?.ownerLookUpId}/surface-waivers/new-lease`);
                break;
            case '4':
                navigate(`${contractsPath}/lease-generation/ownerId/${props?.selectedOwner?.ownerLookUpId}/battery-storage/new-lease`);
                break;
            case '5':
                navigate(`${contractsPath}/lease-generation/ownerId/${props?.selectedOwner?.ownerLookUpId}/brine-leases/new-lease`);
                break;    
            default:
                navigate(contractsPath);
                break;
        }
        console.log('these are the values for the form selection, ', values?.agreementType);
        console.log('what type is this, ', typeof values?.agreementType);
    };

    return (
        <Dialog title={`Manage KUDU Contracts - ${props.selectedOwner?.name}`}>
            <div style={{ width: '70vw' }}>
                <fieldset style={{ padding: '.3rem 0 .3rem 0', borderWidth: '1px 0 0 0' }}>
                    <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Existing Contracts</legend>
                </fieldset>

                {existingContracts !== undefined && (
                    <AgreementsList 
                        pageType="ContractGeneration" 
                        generatedAgreements={existingContracts} 
                        projectNumber={appContext.projectNumber} 
                        clientNumber={appContext.clientNumber} 
                        navigate={(navigate)} 
                    />
                )}
                {existingContracts === undefined && (
                    <div>Loading Contracts...</div>
                )}
            </div>

            <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Generate Contract</legend>
            </fieldset>
            <div>
                <form onSubmit={handleSubmit(formSubmit)}>
                    <div className="mt-1" style={{ display: 'flex' }}>
                        <div>
                            <RHFSelect
                                label="Contract Type"
                                name="agreementType"
                                options={aTypes.map((a) => {
                                    return { value: a.id, label: a.name };
                                })}
                                register={register}
                            />
                        </div>
                        <div className="ml-2 mt-2">
                            <Button text="Generate New Contract" intent="primary" type="submit" />
                        </div>
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default ManageAgreementDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ManageAgreementDialog.redesign.tsx